import { SingleDesignation } from "react-migration/domains/constraints/typings/applicationTypes/SingleDesignation";
import { isDefined } from "react-migration/lib/util/isDefined";

export function numberAttributeAccessor(designation: SingleDesignation, key: string) {
  const rawValue = designation.designation_attributes.find((a) => a.key === key)?.value;
  return isDefined(rawValue) && isFinite(+rawValue) ? +rawValue : null;
}
